
import { NotificationMessage } from '@softools/softools-core';

export const showDownload = (notification: NotificationMessage): boolean => {
  return notification.Tag && notification.Status === 3 && (notification.Tag.indexOf('export_') >= 0 || notification.Tag.indexOf('templatedreport_') >= 0);
};
